"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Document {
}
exports.default = Document;
//# sourceMappingURL=Document.js.map